/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { isInvalid } from 'redux-form';

export const getFormIsInvalidGroupSelector = () =>
	createSelector(isInvalid('orders-change-group-modal'), isInvalid => isInvalid);
